<template>
  <div>
    <div class="create-wrap">
      <div class="flexCenterBetween top" @click="toCreate">
        <div>
          <div class="title">新建答题</div>
          <p>空白答题，完全自定义</p>
        </div>
        <div class="createBtn" @click.stop="toCreate">我要出题</div>
      </div>
      <div class="bottom" @click="toCreate">
        <div class="type-item" v-for="(item, index) in typeLists" :key="index">
          <img :src="item.img" alt="" />{{ item.title }}
        </div>
      </div>
      <WxLink v-if="isWeixin && isMobile && !isInApp" wxPath="/pages/index/index" />
    </div>
    <div class="list-head" v-if="roleType">
      <div
        v-for="(item, index) in headLists"
        :key="index"
        @click="toTemplateCenter(index, item.path)"
        class="list-head-item"
      >
        <div>
          <div class="title">{{ item.title }}</div>
          <p class="desc">{{ item.desc }}</p>
        </div>
        <img
          :src="
            index
              ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/9af047c924ea47b7b38d64c7c56c3408.png'
              : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/0ee219bdd9ca68ec4c20d3404b94267e.png'
          "
          alt=""
        />
      </div>
    </div>
    <div class="list-head active" v-else @click="toTemplate">
      <div class="list-head-item">
        <div>
          <div class="title">{{ headLists[0].title }}</div>
          <p class="desc">{{ headLists[0].desc }}</p>
        </div>
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220420/0ee219bdd9ca68ec4c20d3404b94267e.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  isMobile,
  requestAuth,
  getWxUrl,
  verifyAuth,
  reLogin,
  adClickData,
  isWeixin
} from "@/utils/common";
import api from "@/utils/api";
import WxLink from "@/components/wxLink.vue";
export default {
  props: {
    prePath: {
      type: String,
      default: "lists"
    },
    roleType: {
      type: Number,
      default: 0
    }
  },
  components: { WxLink, isWeixin },
  data() {
    return {
      typeLists: [
        { img: "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/8252eb998e910b55852d54c93fd76574.svg", title: "有奖答题" },
        { img: "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/5396be379be5eff89604322227faebe1.svg", title: "每日一练" },
        { img: "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/507a075f5455d44a7baed24471b5d555.svg", title: "练习答题" },
        { img: "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-31/50323fee8cb92676c39d960bae481c78.svg", title: "调查问卷" }
      ],
      headLists: [
        {
          title: "答题模版",
          desc: "一键复制题目和答题规则",
          path: "templateCenter"
        },
        { title: "计时器", desc: "一键开启，会中计时", path: "timer" }
      ],
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      isInApp: wemeet.app.isTMWebview(),
    };
  },
  methods: {
    async toCreate() {
      this.$emit('toCreate')
    },
    async toTemplateCenter(index, path) {
      if (localStorage.getItem("loginTip")) localStorage.removeItem("loginTip");
      if (index) { //跳转至定时器
        adClickData('meet_timer_card', '计时器卡片')
        this.$router.push({ name: path });
      } else {
        this.toTemplate()
      }
    },
    toTemplate() {
      if(this.isInApp) {
        _hmt.push([
          "_trackEvent",
          "button_to_template",
          "click",
          "templateCenter"
        ]);
        this.$router.push({ name: 'templateCenter' });
      }else {
        this.$emit('toTemplateCenter')
      }
    },
    handleLogin() {
      let path = this.isMobile ? "login" : "createHelp";
      if (this.isMobile) {
        localStorage.setItem("loginTip", 2);
      }
      if (!wemeet.app.isTMWebview()) {
        reLogin();
      } else {
        requestAuth("https://" + api.hostName + ".xiaoxiaodati.com/" + path);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.list-head {
  display: flex;
  justify-content: space-between;
  .list-head-item {
    // width: rem(335);
    flex: 1;
    height: rem(180);
    background: #fff;
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding: rem(30);
    box-sizing: border-box;
    border-radius: rem(8);
    cursor: pointer;
    img {
      width: rem(80);
      min-width: rem(80);
      height: rem(100);
      margin-top: rem(30);
    }
    .title {
      font-size: rem(34);
      font-weight: 700;
      line-height: rem(51);
      margin-bottom: rem(10);
    }
    .desc {
      font-size: rem(28);
      line-height: rem(34);
      color: #999;
    }
  }
  .list-head-item:first-child {
    margin-right: rem(20);
  }
}
.list-head.active{
  margin-top: rem(20);
  .list-head-item{
    height: rem(169);
     img {
      margin-top: rem(15);
    }
    .title{
      margin-bottom: rem(16);
    }
    .desc{
      line-height: rem(42);
    }
  }
}
.list-head.active .list-head-item:first-child {
  margin-right: 0;
}
.create-wrap {
  background: #fff;
  margin: rem(20) 0;
  border-radius: rem(8);
  font-size: rem(28);
  position: relative;
}
.create-wrap .top {
  margin: 0 rem(30);
  padding: rem(30) 0;
  border-bottom: rem(2) solid #eeeeee;
  font-size: rem(28);
  color: #999;
}
.create-wrap .bottom {
  padding: rem(20);
  display: flex;
  justify-content: space-between;
}
.create-wrap .bottom > div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type-item {
  font-size: rem(26);
  color: #999;
}
.type-item img {
  width: rem(30);
  height: rem(30);
  margin-right: rem(7);
}
.create-wrap .top .title {
  font-weight: 700;
  font-size: rem(34);
  line-height: rem(51);
  color: #000;
  margin-bottom: rem(16);
}
.createBtn {
  display: inline-flex;
  color: #fff;
  padding: rem(11) rem(40);
  align-items: center;
  justify-content: center;
  border-radius: rem(32);
  background: #1890ff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/createCard.vue